<template>
  <div :id="$style.saying_screen">
    <div :class="$style.caption">
      <div :class="$style.full">{{ item.full }}</div>
      <!-- <div :class="$style.note">〜{{ item.note }}〜</div> -->
      <div :class="$style.link">{{ item.link }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  name: "SayingScreenVisual",
  props: {
    item: {
      type: Object,
    },
  },
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  #saying_screen {
    width: 100%;
    // height: 300px;
    height: 580px;
    //background: radial-gradient(#fff 70%, #707070);
    background: radial-gradient(#eff 70%, #cacede);
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    //text-align: center;
    white-space: pre-line;
    .caption {
      text-orientation: upright;
      writing-mode: vertical-rl;
      position: relative;
      animation: fadeIn 2s ease 0s 1 normal;
      @keyframes fadeIn {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
      .full {
        // height: 200px;
        height: 480px;
        width: 100%;
        padding: 0 35px;
        font-size: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        //font-family: YuMincho;
        //line-height: 1.3;
      }
      .note {
        font-size: 15px;
        font-family: YuGothic;
      }
      .link {
        position: absolute;
        color: #707070;
        margin-top: 5px;
        font-size: 10px;
        //font-family: YuGothic;
        //padding: 0 35px;
        margin-bottom: 10px;
        bottom: 0%;
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  #saying_screen {
    width: 65%;
    min-height: 350px;
    //background: radial-gradient(#fff 70%, #707070);
    background: radial-gradient(#eff 70%, #cacede);
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    white-space: pre-line;
    line-height: 40px;
    .caption {
      text-orientation: upright;
      writing-mode: vertical-rl;
      position: relative;
      animation: fadeIn 2s ease 0s 1 normal;
      @keyframes fadeIn {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
      .full {
        height: 600px;
        width: 600px;
        font-size: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        //font-family: YuMincho;
      }
      .note {
        font-size: 20px;
        font-family: YuGothic;
      }
      .link {
        position: absolute;
        color: #707070;
        //font-family: YuGothic;
        margin-bottom: 20px;
        bottom: 0%;
        left: 5%;
        font-size: 14px;
      }
    }
  }
}
</style>
